// extracted by mini-css-extract-plugin
module.exports = {"footer":"FooterBar_footer__3bPuO","title":"FooterBar_title__35VHk","content":"FooterBar_content__14fur"};